<template>
  <modal
    name="presentationLink"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
    :clickToClose="false"
    :width="446"
    :height="172"
    :min-height="172"
  >
    <div class="container">
      <div class="heading">
        <div class="text">PPT演示链接已生成，复制即可进行分享与演示</div>
        <div class="small-text">请使用电脑浏览器打开</div>
        <div class="close icon-popup-close" @click="close"></div>
      </div>
      <div class="content">
        <div class="copy-content">
          <div class="copy-url">{{address}}</div>
          <div :class="['copy-btn', hasCopy&&'has-copy']" @click="copyAddress">{{hasCopy?'已复制':'复制'}}</div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  data () {
    return {
      address: '',
      hasCopy: false,
      source: ''
    }
  },
  computed: {
    ...mapGetters([
      'WorksProjectId',
      'historyVersionList',
      'cooperationDraftId',
      'cooperationDraftOwnerId',
      'WorksTemplateIds'
    ])
  },
  methods: {
    copyAddress () {
      if (this.hasCopy) return;
      this.hasCopy = true;
      setTimeout(() => {
        this.hasCopy = false;
      }, 1000)
      let ok = this.copyToClipboard(this.address);
      if (!ok) {
        console.error('copy failed')
      }
      window.sensors.track('laipicCopyLink', {
        source: this.source,
        template_id: this.WorksTemplateIds.join(',')
      });
    },
    copyToClipboard(text) {
      let suc = false
      try {
        navigator.clipboard.writeText(text);
      } catch (err) {
        suc = false
      }
      return suc;
    },
    close () {
      this.$modal.hide('presentationLink');
    },
    beforeOpen ({params}) {
      this.source = params.source;
      this.address = `${window.location.origin}/draftpreview/index.html?id=${window.draftId || this.WorksProjectId}&presentation=1`
    },
  }
}
</script>

<style scoped lang="scss">
.container {
  background: #fff;
  width: 100%;
  height: 100%;
}
.heading {
  position: relative;
  padding: 32px;
  padding-bottom: 20px;
  color: #474261;
  .text {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 8px;
  }

  .close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
}
.content {
  padding-left: 32px;
  padding-right: 32px;
}
.copy-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #E4E4E4;
  margin-right: 20px;
  background: #F8F8FC;
}
.copy-url {
  width: 300px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  // overflow-x: scroll;
  // overflow-y: hidden;
  user-select: text !important;
  color: #8F9198;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &::-webkit-scrollbar {
    display: none;
  }
}
.copy-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 81px;
  height: 40px;
  background: #5778FB;
  opacity: 1;
  border-radius: 0px 5px 5px 0px;
  cursor: pointer;
  color: #fff;
}
.has-copy {
  background-color: #52C41A;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/presentation/presentationLink.vue